import http from '@/common/utils/http-common';
import { MyGroup } from '@/types/MyGroup.type';

class MyGroupService {
  getAvailables() {
    return http.get(`/my-groups/`);
  }

  getEditables() {
    return http.get(`/my-groups/?editable=1`);
  }

  get(id: any) {
    return http.get(`/my-groups/${id}`);
  }

  create(data: MyGroup) {
    return http.post('/my-groups', data);
  }

  update(data: MyGroup, id: any) {
    return http.put(`/my-groups/${id}`, data);
  }

  delete(id: any) {
    return http.delete(`/my-groups/${id}`);
  }
}

export default new MyGroupService();
